import axiosInstance from "../axios/axiosConfig";
import { SHOPPING_CART_API } from "../constants/api-constants";

export const postEventPackageToShoppingCart = async (data) => {
  try {
    const response = await axiosInstance.post(SHOPPING_CART_API.ADD_SHOPPING_CART_ITEM, {
      productId: data,
    });
    return response.data;
  } catch (error) {
    throw new Error(SHOPPING_CART_API.ADD_SHOPPING_CART_ITEM_ERROR);
  }
};
